import type { IconComponentProps } from "..";

export function AndroidIcon(props: IconComponentProps) {
	return (
		<svg
			{...props}
			fill="currentColor"
			role="img"
			viewBox="67.13 261.91 264.41 148.27"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Android</title>
			<path d="m263.84 306.59 21.933-37.994c1.2377-2.13 0.48933-4.8356-1.6119-6.0734-2.1012-1.2377-4.8356-0.5181-6.0446 1.6119l-22.221 38.484c-16.954-7.7428-36.037-12.06-56.56-12.06-20.523 0-39.606 4.3175-56.56 12.06l-22.221-38.484c-1.2377-2.13-3.9434-2.8496-6.0734-1.6119-2.13 1.2377-2.8496 3.9434-1.6119 6.0734l21.933 37.994c-37.822 20.494-63.439 58.776-67.67 103.59h264.41c-4.2312-44.816-29.849-83.098-67.699-103.59zm-125.21 66.461c-6.1309 0-11.082-4.9796-11.082-11.082 0-6.1309 4.9796-11.082 11.082-11.082 6.1309 0 11.082 4.9796 11.082 11.082 0.0289 6.1021-4.9508 11.082-11.082 11.082zm121.38 0c-6.1309 0-11.082-4.9796-11.082-11.082 0-6.1309 4.9796-11.082 11.082-11.082 6.1309 0 11.082 4.9796 11.082 11.082 0.0288 6.1021-4.9508 11.082-11.082 11.082z" />
		</svg>
	);
}
